import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule, SharedPipesModule } from '@grid-ui/common';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DisclaimerModalComponent } from './disclaimer-modal.component';
import { DisclaimerModalService } from './services';

@NgModule({
  imports: [CommonModule, NgbModalModule, NgbTooltipModule, SharedPipesModule, IconModule],
  declarations: [DisclaimerModalComponent],
  exports: [DisclaimerModalComponent],
  providers: [DisclaimerModalService],
})
export class DisclaimerModalModule {}
